import 'normalize.css'
import './scss/main.scss'
import './js/main'
import './js/dropdown'
import './js/validation'
